import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import helpers from "utils/helpers";
import ONotificationTableHead from "../../components/reusable/OTableHead";
import { v4 as uuidv4 } from 'uuid';
import useToastContext from "hooks/useToastContext";
import { apiDelete } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import { MdDelete } from "react-icons/md";

const NotificationTable = ({ notifications, paginationObj, sort, setSort, pageSize, getAllNotifications }) => {
  const { t } = useTranslation();

  const notification = useToastContext()
  const handleDelete = async (data) => {
    try {

      const result = await apiDelete(helpers.ternaryCondition(!isEmpty(data), apiPath.deleteNotification + '/' + data?._id, apiPath.deleteNotification))
      if (result?.data?.success) {
        notification.success(result?.data?.message)
        getAllNotifications()
        return
      }
      notification.error(result?.data?.message)
    } catch (error) {
      console.error('error ', error)
    }

  };


  return (
    <div className="p-3">
      {helpers.andOperator(notifications?.length>0,<div className="flex justify-end mb-3">
        <button
          className="bg-red-200 rounded-lg px-6 py-1 text-sm"
          title="Clear All"
          onClick={() => helpers.alertFunction(`Are you sure you want to delete all notification?`, null, handleDelete)}
        >
          Clear All
        </button>
      </div>)}
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6 text-center">
                {t("S.NO")}
              </th>
              <ONotificationTableHead sort={sort} setSort={setSort} name="O_TITLE" fieldName="title" classTd={"justify-center"} />
              <ONotificationTableHead sort={sort} setSort={setSort} name="O_CREATED_AT" fieldName="createdAt" classTd={"justify-center"} />
              <ONotificationTableHead sort={sort} setSort={setSort} name="O_MESSAGE" fieldName="description" classTd={"justify-center"} />
              <th className="py-3 px-6 text-center"> {t("O_ACTION")}</th>
            </tr>
          </thead>
          <tbody>
            {notifications?.map((item, i) => (
              <tr key={uuidv4()} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th scope="row" className="py-4 px-6 text-center border-r font-medium text-gray-900  dark:text-white">
                  {i + 1 + pageSize * (paginationObj?.page - 1)}
                </th>
                <td className="py-2 px-6 border-r text-center">{helpers.capitalizeFirstWord(item?.title) || "N/A"}</td>
                <td className="py-2 px-6 border-r text-center">{helpers.getDateAndTime(item?.createdAt)}</td>
                <td className="py-2 px-6 border-r text-center">{helpers.capitalizeFirstWord(item?.description) || "N/A"}</td>
                <td className="py-2 px-6 border-r text-center">
                  <button
                    className="bg-red-100 rounded-full p-1 hover:bg-red-200"
                    title="delete"
                    onClick={() => helpers.alertFunction(` ${t("DELETE_NOTIFICATION")}`, item, handleDelete)}
                  >
                    <MdDelete size={20} className="text-red-600" />
                  </button>
                </td>
              </tr>
            ))}
            {isEmpty(notifications) && (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={6}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NotificationTable;
